import formScreen from "./formScreen";
import error from "./error";
import selectionCheckboxes from "model/selectors-tree/selectionCheckboxes";

export default {
  selectionCheckboxes,
  formScreen,
  error
};
